import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';

import { combineLatest, forkJoin } from 'rxjs';
import { ImageGalleryComponent } from 'src/app/components/shared/image-gallery/image-gallery.component';
import { ClientService } from 'src/app/services/client.service';
import { ContractService } from 'src/app/services/contract.service';
import { OverlayService } from 'src/app/services/overlay.service';
import { PropertyService } from 'src/app/services/property.service';
import {
	AccessibilityHelp,
	Alignment,
	AutoLink,
	Autosave,
	BalloonToolbar,
	BlockQuote,
	Bold,
	Essentials,
	FontBackgroundColor,
	FontColor,
	FontFamily,
	FontSize,
	GeneralHtmlSupport,
	Heading,
	Highlight,
	HorizontalLine,
	Indent,
	IndentBlock,
	Italic,
	Link,
  List,
	Paragraph,
	RemoveFormat,
	SelectAll,
	SpecialCharacters,
	Strikethrough,
	Underline,
	Undo,
  ClassicEditor
} from 'ckeditor5';

import translations from 'ckeditor5/translations/de.js';
@Component({
  selector: 'app-base',
  templateUrl: './base.component.html',
  styleUrls: ['./base.component.scss']
})
export class BaseComponent implements OnInit {
  client = null;
  allProperties = null;
  clientProperties = null;
  clientConfiguration = [];
  services = [];
  legalInformation = [];

  parameterData = null;
  officeHours = null;
  address = null;
  layoutData = {
    MAIN_FONT: '',
    CAROUSEL_FONT_COLOR: '',
    MAIN_COLOR: '',
    CAROUSEL_COLOR: ''
  };

  basicDataHasChanged = false;
  serviceHasChanged = [];
  addressHasChanged = false;
  legalHasChanged = [];
  hintchanged: boolean = false;
  layoutChanged:boolean = false;
  serviceFilter = null;
  actual_hint = "";
  legalSections = [
    { title: 'Teilnahmebedingungen', key: 'participation' },
    { title: 'Datenschutzhinweise', key: 'privacy' },
    { title: 'Impressum', key: 'about' },
    { title: 'Kontakt', key: 'contact' }
  ];

  imageProperties = [
    // { showValue: 'Logo', key: 'logo', value: null, hint: 'Format: 180 x 90, Typ: .png', hasChanged: false },
    // { showValue: 'Favicon', key: 'favicon.path', value: null, hint: 'Format: 16 x 16, Typ: .ico', hasChanged: false },
    // { showValue: 'Appleicon', key: 'appletouchicon.path', value: null, hint: 'Format: 76 x 76, Typ: .png', hasChanged: false }
  ];

  public Editor = ClassicEditor;
  public config = {
    toolbar: {
      items: [
        'undo',
        'redo',
        '|',
        'heading',
        '|',
        'bold',
        'italic',
        'underline',
        'strikethrough',
        '|',
        'link',
        'alignment',
        '|',
        'bulletedList',
        'numberedList',
        'outdent',
        'indent'
      ],
      shouldNotGroupWhenFull: true
    },
    plugins: [
      AccessibilityHelp,
      Alignment,
      AutoLink,
      Autosave,
      BalloonToolbar,
      BlockQuote,
      Bold,
      Essentials,
      FontBackgroundColor,
      FontColor,
      FontFamily,
      FontSize,
      GeneralHtmlSupport,
      Heading,
      Highlight,
      HorizontalLine,
      Indent,
      IndentBlock,
      Italic,
      Link,
      Paragraph,
      RemoveFormat,
      SelectAll,
      SpecialCharacters,
      Strikethrough,
      Underline,
      Undo,
      List
    ],
    heading: {
      options: [
        {
          model: 'paragraph',
          title: 'Paragraph',
          class: 'ck-heading_paragraph'
        },
        {
          model: 'heading1',
          view: 'h1',
          title: 'Überschrift 1',
          class: 'ck-heading_heading1'
        },
        {
          model: 'heading2',
          view: 'h2',
          title: 'Überschrift 2',
          class: 'ck-heading_heading2'
        },
        {
          model: 'heading3',
          view: 'h3',
          title: 'Überschrift 3',
          class: 'ck-heading_heading3'
        },   
        {
          model: 'heading4',
          view: 'h4',
          title: 'Überschrift 4',
          class: 'ck-heading_heading4'
        },        
      ]
    },
    htmlSupport: {
      allow: [
        {
          name: /^.*$/,
          styles: true,
          attributes: true,
          classes: true
        }
      ]
    },
    language: 'de',
    link: {
      addTargetToExternalLinks: true,
      defaultProtocol: 'https://',
      decorators: {
        toggleDownloadable: {
          mode: 'manual',
          label: 'Downloadable',
          attributes: {
            download: 'file'
          }
        }
      }
    },
    placeholder: '',
    translations: [translations]
  }

  constructor(
    private clientService: ClientService,
    private propertyService: PropertyService,
    private contractService: ContractService,
    private overlayService: OverlayService,
    private dialog: MatDialog) { }

  ngOnInit() {
    this.propertyService.getProperty();

    combineLatest([
      this.propertyService.getProperties(),
      this.propertyService.getPropertyConfiguration(),
      this.clientService.getClientAddress()
    ]).subscribe(res => {
      console.log(res)
      this.allProperties = res[0];
      this.clientProperties = res[1];
      this.address = res[2];

      this.clientProperties.forEach(element => {
        switch (element.publicId) {
          case 'CAROUSSEL_FONT_COLOR':
            this.layoutData.CAROUSEL_FONT_COLOR = element.value
            break;
          case 'MAIN_FONT':
            this.layoutData.MAIN_FONT = element.value
            break;
          case 'MAIN_COLOR':
            this.layoutData.MAIN_COLOR = element.value
            break;
          case 'CAROUSEL_COLOR':
            this.layoutData.CAROUSEL_COLOR = element.value
            break;
          default:
            break;
        }
      });


      if (!this.address.location) {
        this.address.location = {};
      }

      this.extractProperties();
      this.loadBasisInformation();
      this.setClientConfiguration();
    });
  }

  setClientConfiguration() {
    const toSkip = this.imageProperties.map(prop => prop.key);
    toSkip.push('officehours.notification');

    this.clientConfiguration = Object.keys(this.allProperties).map(key => {
      for (let p of this.clientProperties) {
        if (p.publicId == key && toSkip.indexOf(key) < 0) {
          return { ... this.allProperties[key], value: p.value, publicId: key }
        }
      }
      return false
    }).filter(val => val);

    this.clientConfiguration.forEach(element => {
      if (element.publicId == "actual_hint") {
        this.actual_hint = element.value
      }
    })
  }

  extractProperties() {
    for (let p in this.clientProperties) {
      const property = this.clientProperties[p];
      if (property.publicId == 'officehours.notification') {
        this.officeHours = JSON.parse(property['value']).map(entry => {
          return { value: entry, hasChanged: false }
        });
      } else {
        const imageKeys = this.imageProperties.map(val => val.key);
        const index = imageKeys.indexOf(property['key']);
        if (index >= 0) {
          this.updateImageSrc(property, index);
        }
      }
    }
  }



  loadBasisInformation() {
    if (!this.client) {
      this.clientService.getClient().subscribe(res => {
        this.client = res;
      });
    }
  }


  saveProperty(property) {
    this.propertyService.updateProperty(property.publicId, property.value).subscribe({
      next: () => {
        this.overlayService.openSnackBar('Wert erfolgreich aktualisiert.');
      },
      error: (err) => {
        this.overlayService.openSnackBar(`Fehler beim Aktualisieren: ${err.error.message}`, 'error');
      }
    });
  }

  saveImage(imageProperty) {
    const toSave = {
      value: imageProperty.newValue,
      publicId: imageProperty.key
    }
    this.saveProperty(toSave);
  }

  removeHour(index) {
    this.officeHours.splice(index, 1);
    this.saveOfficeHours();
  }

  addOfficeHourRow() {
    this.officeHours.push({ value: '', hasChanged: false })
  }

  saveOfficeHours() {
    const hoursString = JSON.stringify(this.officeHours.map(entry => entry.value));
    this.propertyService.updateProperty('officehours.notification', hoursString).subscribe({
      next: () => {
        this.overlayService.openSnackBar('Öffnungszeiten erfolgreich aktualisiert.');
      },
      error: (err) => {
        this.overlayService.openSnackBar(`Fehler beim Aktualisieren: ${err.error.message}`, 'error');
      }
    });
  }

  saveBasicData() {
    this.clientService.updateClient(this.client).subscribe({
      next: () => {
        this.overlayService.openSnackBar('Wert erfolgreich aktualisiert.');
        this.addressHasChanged = false;
      },
      error: (err) => {
        this.overlayService.openSnackBar(`Fehler beim Aktualisieren: ${err.error.message}`, 'error');
      }
    })
  }

  getCoordinates() {
    // this.clientService.getGoogleAddressCoordinates(this.address).subscribe(res => {
    //   console.log('google: ', res);
    // });
  }

  saveAddress() {
    this.clientService.updateClientAddress(this.address).subscribe({
      next: () => {
        this.overlayService.openSnackBar('Wert erfolgreich aktualisiert.');
        this.addressHasChanged = false;
      },
      error: (err) => {
        this.overlayService.openSnackBar(`Fehler beim Aktualisieren: ${err.error.message}`, 'error');
      }
    })
  }

  updateImageSrc(property, propertyImageIndex) {
    let result: String;

    if (property.value != null) {
      switch (property.key) {
        case 'appletouchicon.path':
        case 'favicon.path':
          result = this.clientService.getFileURL(property.value);
          break;
        case 'logo':
          result = this.clientService.getAttachmentURL(property.value);
          break;
        default: ''
      }
    }
    this.imageProperties[propertyImageIndex].value = result;
  }

  openImageGallery(property) {
    const dialogRef = this.dialog.open(ImageGalleryComponent);
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        property.value = result.url;
        property.hasChanged = true;
        property.newValue = `${result.publicId}`;
      }
    });
  }

  editActualHint() {
    this.propertyService.updateProperty("actual_hint", ((this.actual_hint != null) ? this.actual_hint : '')).subscribe({
      next: () => {
        this.overlayService.openSnackBar('Wert erfolgreich aktualisiert.');
        this.addressHasChanged = false;
      },
      error: (err) => {
        this.overlayService.openSnackBar(`Fehler beim Aktualisieren: ${err.error.message}`, 'error');
      }
    });
  }

  saveLayoutData(){


    this.propertyService.updateProperty("MAIN_FONT", ((this.layoutData.MAIN_FONT != null) ? this.layoutData.MAIN_FONT : '')).subscribe({
      next: () => {
        this.overlayService.openSnackBar('Wert erfolgreich aktualisiert.');
        this.addressHasChanged = false;
      },
      error: (err) => {
        this.overlayService.openSnackBar(`Fehler beim Aktualisieren: ${err.error.message}`, 'error');
      }
    });


    this.propertyService.updateProperty("CAROUSEL_COLOR", ((this.layoutData.CAROUSEL_COLOR != null) ? this.layoutData.CAROUSEL_COLOR : '')).subscribe({
      next: () => {
        this.overlayService.openSnackBar('Wert erfolgreich aktualisiert.');
        this.addressHasChanged = false;
      },
      error: (err) => {
        this.overlayService.openSnackBar(`Fehler beim Aktualisieren: ${err.error.message}`, 'error');
      }
    });


    this.propertyService.updateProperty("CAROUSEL_FONT_COLOR", ((this.layoutData.CAROUSEL_FONT_COLOR != null) ? this.layoutData.CAROUSEL_FONT_COLOR : '')).subscribe({
      next: () => {
        this.overlayService.openSnackBar('Wert erfolgreich aktualisiert.');
        this.addressHasChanged = false;
      },
      error: (err) => {
        this.overlayService.openSnackBar(`Fehler beim Aktualisieren: ${err.error.message}`, 'error');
      }
    });

    this.propertyService.updateProperty("MAIN_COLOR", ((this.layoutData.MAIN_COLOR != null) ? this.layoutData.MAIN_COLOR : '')).subscribe({
      next: () => {
        this.overlayService.openSnackBar('Wert erfolgreich aktualisiert.');
        this.addressHasChanged = false;
      },
      error: (err) => {
        this.overlayService.openSnackBar(`Fehler beim Aktualisieren: ${err.error.message}`, 'error');
      }
    });



  }
}
